import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Ventures from "./components/Ventures";
import About from "./components/About";
import FounderMessage from "./components/FounderMessage";
import GetInTouch from "./components/GetInTouch";
import Footer from "./components/Footer";




function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Ventures />
      <About />
       <FounderMessage />
       <GetInTouch />
       <Footer />


    </>
  );
}

export default App;
